import React, { ReactElement } from 'react';

import { COLORS } from 'constants/theme';

import { TIconProps } from './Icons.types';

function CloseIcon({
  height = 15,
  width = 15,
  iconColor = COLORS.grayTertiary,
  ...restProps
}: TIconProps): ReactElement {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 15 15"
      data-testid="CloseIcon"
      {...restProps}>
      <path
        d="M13.542.25L7.5 6.293 1.46.251A.853.853 0 10.25 1.459L6.292 7.5.251 13.542a.853.853 0 101.208 1.208L7.5 8.708l6.042 6.042a.852.852 0 001.208 0 .853.853 0 000-1.208L8.708 7.5 14.75 1.46A.853.853 0 1013.542.25z"
        fill={iconColor}
        fillRule="evenodd"
      />
    </svg>
  );
}

export default CloseIcon;
